import React from "react";
import gift1 from "../../../assets/images/gift1.png";
import gift2 from "../../../assets/images/gift2.png";
import autoImage from "../../../assets/images/landingCarImage2Alt.png";
import "./Footer.css";
import {useHistory} from "react-router-dom";
import {makeStyles} from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
    mainRowDiv: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        width: "100%",
    },
    leftDiv: {
        width: "40%", display: "flex", marginLeft: "5%",
        flexDirection: "row", justifyContent: "space-between", paddingRight: "5%",
    },
    middleDiv: {
        minWidth:"fit-content", width: "20%", display: "flex",
        flexDirection: "row", justifyContent: "center",
    },
    rightDiv: {
        width: "40%", display: "flex",
        flexDirection: "row", justifyContent: "space-between", paddingLeft: "5%",
    },
    carImage: {
        [theme.breakpoints.up('xl')]: {
            width: "400px",
            height: "300px",
        },
        [theme.breakpoints.down('xl')]: {
            width: "360px",
            height: "280px",
        },
        [theme.breakpoints.down('lg')]: {
            width: "288px",
            height: "232px",
        },
        [theme.breakpoints.down('md')]: {
            width: "240px",
            height: "196px",
        },
        [theme.breakpoints.down('sm')]: {
            width: "192px",
            height: "160px",
        },
    },
    btnIngresar: {
        borderRadius: "60px",
        color: "#ffffff",
        background: "#000000",
        border: "solid #000000 2px",
        fontFamily: "PoppinsBold",
        marginTop: "100px",
        '&:hover': {
            background: "#bb0d67",
            border: "solid #bb0d67 2px",
        },
        [theme.breakpoints.up('xl')]: {
            fontSize: "42px",
            padding: "8px 48px",
            height: "75px",
        },
        [theme.breakpoints.down('xl')]: {
            fontSize: "42px",
            padding: "8px 48px",
            height: "75px",
        },
        [theme.breakpoints.down('lg')]: {
            fontSize: "32px",
            padding: "8px 48px",
            height: "75px",
        },
        [theme.breakpoints.down('md')]: {
            fontSize: "32px",
            padding: "4px 24px",
            height: "75px",
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: "24px",
            padding: "4px 24px",
            height: "75px",
        },
    },
    exclamationMark: {
        margin: "-50px",
        height: "300px",
        marginRight: "96px",
        lineHeight: "1",
        [theme.breakpoints.up('xl')]: {
            fontSize: "290px",
        },
        [theme.breakpoints.down('xl')]: {
            fontSize: "290px",
        },
        [theme.breakpoints.down('lg')]: {
            fontSize: "240px",
        },
        [theme.breakpoints.down('md')]: {
            fontSize: "200px",
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: "180px",
        },
    }
}));

const Footer = (props) => {
    const classes = useStyles();
    const history = useHistory();
    return (
        <React.Fragment>
            <div className={classes.mainRowDiv}>
                <div className={classes.leftDiv}>
                    <img
                        src={gift1}
                        style={{width: "90px", height: "100px"}}
                    />
                </div>

                <div className={classes.middleDiv}>
                    <button
                        className={classes.btnIngresar}
                        onClick={() => history.push({pathname: `/a/${props.CodigoProductor}/${props.affinityId}/productos`})}>
                        ACTIVÁ TUS BENEFICIOS
                    </button>
                </div>
                <div className={classes.rightDiv}>
                    <img
                        src={gift2}
                        style={{
                            width: "100px",
                            height: "110px",
                        }}
                    />
                    <h2 className={`${classes.exclamationMark} font-face-poppins-bold exclamation-mark3`}>
                        !
                    </h2>
                </div>
            </div>
        </React.Fragment>
    );
};

export default Footer;
